import { haveFilterQuery, paginator, haveSort } from '../../common/auxFun'

const endpointsNotifications = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/purchases/notifications${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  ADD: (id) => `/v1/purchases/notifications/${id}/user`,
  REMOVE: (id, userId) => `/v1/purchases/notifications/${id}/user/${userId}`,
}

export default endpointsNotifications
